import Link from 'next/link'
import React from 'react'

interface PhasePanelProps {
  title: string
  content?: string
  links: {
    label: string
    href: string
  }[]
}

export const PhasePanel: React.FC<PhasePanelProps> = ({ title, content, links = [] }) => {
  return (
    <div className="flex flex-col bg-clouds rounded-[1rem] py-[40px] px-[20px] h-[300px] w-full">
      <div className="font-secondary font-bold text-[20px] leading-[30px] text-darkgray min-h-[50px] overflow-hidden">
        {title}
      </div>
      <div className="flex-1 font-primary font-regular text-[16px] leading-[19px] text-darkgray my-[10px]">
        {content}
      </div>
      <div className="flex flex-col">
        {links?.map((item, idx) => {
          return (
            <Link
              key={idx}
              href={item.href}
              passHref
              className="font-primary font-bold text-[15px] leading-[18px] w-full text-left mt-[17px] cursor-pointer text-textdark underline"
            >
              {item.label}
            </Link>
          )
        })}
      </div>
    </div>
  )
}
